// Shared styles for table filters in Reports, OneLinks, Users and Inventory

export const containerStyles = {
  width: '100%',
};

export const headerStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  flexDirection: { xs: 'column', sm: 'row' },
  gap: { xs: 2, sm: 0 },
};

export const searchContainerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: { xs: 1, sm: 2.5 },
  width: { xs: '100%', sm: 'auto' },
  mb: { xs: 2, sm: 0 },
};

export const filtersRowStyles = {
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  justifyContent: 'space-between',
  alignItems: { xs: 'stretch', md: 'center' },
  mt: { xs: 2, md: 2.5 },
  gap: { xs: 2, md: 0 },
};

export const filtersContainerStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: { xs: 1.5, sm: 3 },
  overflowX: { xs: 'auto', sm: 'visible' },
  pb: { xs: 1, sm: 0 },
};
